<div fxLayout="column" class="fee-comparison-display">
  <div class="stats-row">
    <div class="stat-block">
      <div class="stat-block__header">
        <img src="./assets/images/svg/money-stack.png" alt="" class="stat-block__icon" style="width: 42px; height: 42px;">
        <span class="stat-block__title">Fees</span>
      </div>
      <hr class="stat-block__divider">
      <div class="stat-block__row">
        <span class="stat-block__label">current</span>
        <span class="stat-block__value">{{getCurrentTotalMonthlyFees() | currency}}</span>
      </div>
      <hr class="stat-block__divider">
      <div class="stat-block__row">
        <span class="stat-block__label stat-block__label--bold">proposed</span>
        <span class="stat-block__value stat-block__value--bold">{{getProposedTotalMonthlyFees() | currency}}</span>
      </div>
    </div>

    <div class="stat-block">
      <div class="stat-block__header">
        <img src="./assets/images/svg/percent.png" alt="" class="stat-block__icon">
        <span class="stat-block__title">Rates</span>
      </div>
      <hr class="stat-block__divider">
      <div class="stat-block__row">
        <span class="stat-block__label">current</span>
        <span class="stat-block__value">{{getCurrentEffectiveRate() | percent: '1.2-2'}}</span>
      </div>
      <hr class="stat-block__divider">
      <div class="stat-block__row">
        <span class="stat-block__label stat-block__label--bold">proposed</span>
        <span class="stat-block__value stat-block__value--bold">{{getProposedEffectiveRate() | percent: '1.2-2'}}</span>
      </div>
    </div>

    <div class="stat-block">
      <div class="stat-block__header">
        <img src="./assets/images/svg/piggy-bank.png" alt="" class="stat-block__icon" style="width: 42px; height: 42px;">
        <span class="stat-block__title">Savings</span>
      </div>
      <hr class="stat-block__divider">
      <div class="stat-block__row">
        <span class="stat-block__label stat-block__label--bold">monthly</span>
        <span class="stat-block__value stat-block__value--bold">{{getSavingsTotalMonthlyFees() | currency}}</span>
      </div>
      <hr class="stat-block__divider">
      <div class="stat-block__row">
        <span class="stat-block__label stat-block__label--bold">annual</span>
        <span class="stat-block__value stat-block__value--bold">{{getSavingsTotalMonthlyFees() * 12 | currency}}</span>
      </div>
    </div>
  </div>

  @if (costComparison.notes) {
  <div class="notes-container">
    <div class="notes-card">
      <span class="notes-card-title">Message from proposal preparer:</span>
      <div class="notes-card-content white-space-pre-wrap">{{costComparison.notes}}</div>
      <span class="notes-card-signature">- Sam from Swipesum</span>
    </div>
  </div>
  }

  <div class="fee-table">
    <table class="fees-table processor-fees-table full-width" (click)="toggleProcessorTable()">
      <colgroup>
        <col style="width: 20%">
        <col style="width: 8%">
        <col style="width: 10%">
        <col style="width: 8%">
        <col style="width: 7%">
        <col style="width: 9%">
        <col style="width: 8%">
        <col style="width: 7%">
        <col style="width: 9%">
        <col style="width: 14%">
      </colgroup>
      <thead>
        <tr class="group-header-row">
          <th colspan="3" class="group-header group-header--title">
            <div class="group-header__title-inner">
              <span class="material-symbols-outlined table-header-icon">
                {{processorFees.length ? 'expand_circle_up' : 'expand_circle_down'}}
              </span>
              {{getFeeGroupingDisplayName('processor', 'Processor Fees')}}
            </div>
          </th>
          <th colspan="3" class="group-header group-header--current">Current Provider</th>
          <th colspan="3" class="group-header group-header--proposed">Proposed Rates</th>
          <th class="group-header group-header--savings">Savings</th>
        </tr>
        <tr class="column-header-row">
          <th class="col-header" (click)="$event.stopPropagation(); sortProcessorFees()" style="cursor: pointer;">
            Name {{processorSortDirection === 'asc' ? '↑' : '↓'}}
          </th>
          <th class="col-header col-header--right"># Trans</th>
          <th class="col-header col-header--right">Volume</th>
          <th class="col-header col-header--right">Rate</th>
          <th class="col-header col-header--right">Fixed</th>
          <th class="col-header col-header--right">Total Fees</th>
          <th class="col-header col-header--right">Rate</th>
          <th class="col-header col-header--right">Fixed</th>
          <th class="col-header col-header--right">Total Fees</th>
          <th class="col-header col-header--right">Monthly Savings</th>
        </tr>
      </thead>
      <tbody>
        @for (procFee of processorFees; track procFee) {
        <tr class="data-row" [class.data-row--parent]="!procFee.isFeeDetail"
          [class.data-row--child]="procFee.isFeeDetail">
          <td class="cell" [class.cell--indented]="procFee.isFeeDetail" [class.cell--bold]="!procFee.isFeeDetail">
            {{procFee.description}}
          </td>
          <td class="cell cell--right">
            @if (procFee.monthlyTransactions || procFee.totalTransactions) {
            {{procFee.monthlyTransactions || procFee.totalTransactions | number}}
            } @else {
            ---
            }
          </td>
          <td class="cell cell--right" [class.cell--bold]="!procFee.isFeeDetail">
            {{procFee.volume || procFee.totalVolume | currency}}
          </td>
          <td class="cell cell--right cell--current" [class.cell--bold]="!procFee.isFeeDetail">
            {{procFee.transactionRate | percent:'1.2-3'}}
          </td>
          <td class="cell cell--right cell--current" [class.cell--bold]="!procFee.isFeeDetail">
            @if (!processorFeeIsEmptyOrZero(procFee.transactionFee)) {
            {{procFee.transactionFee | currency:'USD':'symbol':'1.2-3'}}
            } @else if (procFee.isFeeDetail) {
            ---
            }
          </td>
          <td class="cell cell--right cell--current" [class.cell--bold]="!procFee.isFeeDetail">
            @if (procFee.isFeeDetail) {
            {{procFee.amount | currency}}
            } @else {
            {{procFee.totalAmount | currency}}
            }
          </td>
          <td class="cell cell--right cell--proposed" [class.cell--bold]="!procFee.isFeeDetail">
            {{procFee.proposedRate | percent:'1.2-3'}}
          </td>
          <td class="cell cell--right cell--proposed" [class.cell--bold]="!procFee.isFeeDetail">
            @if (!processorFeeIsEmptyOrZero(procFee.proposedFee)) {
            {{procFee.proposedFee | currency:'USD':'symbol':'1.2-3'}}
            } @else {
            ---
            }
          </td>
          <td class="cell cell--right cell--proposed" [class.cell--bold]="!procFee.isFeeDetail">
            @if (procFee.isFeeDetail) {
            {{procFee.proposedAmount | currency}}
            } @else {
            {{procFee.proposedTotalAmount | currency}}
            }
          </td>
          <td class="cell cell--right cell--savings" [class.cell--bold]="!procFee.isFeeDetail">
            @if (procFee.isFeeDetail) {
            {{getFeeSavings(procFee) | currency}}
            } @else {
            {{getProcFeeSavings(procFee) | currency}}
            }
          </td>
        </tr>
        }
      </tbody>
      <tfoot>
        <tr class="footer-row">
          <td class="cell cell--bold">Total</td>
          <td class="cell cell--right cell--bold">{{costComparison.comparisonFeeGroupings.processor.totalTransactions |
            number}}</td>
          <td class="cell cell--right cell--bold">{{costComparison.comparisonFeeGroupings.processor.totalVolume |
            currency}}</td>
          <td class="cell cell--current"></td>
          <td class="cell cell--current"></td>
          <td class="cell cell--right cell--bold cell--current">
            {{costComparison.comparisonFeeGroupings.processor.totalAmount | currency}}</td>
          <td class="cell cell--proposed"></td>
          <td class="cell cell--proposed"></td>
          <td class="cell cell--right cell--bold cell--proposed">
            {{costComparison.comparisonFeeGroupings.processor.proposedTotalAmount | currency}}</td>
          <td class="cell cell--right cell--bold cell--savings">
            {{getFeeGroupingSavings(costComparison.comparisonFeeGroupings.processor) | currency}}</td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div class="fee-table">
    <table class="fees-table additional-fees-table full-width" (click)="toggleAdditionalTable()">
      <colgroup>
        <col style="width: 30%">
        <col style="width: 25%">
        <col style="width: 25%">
        <col style="width: 20%">
      </colgroup>
      <thead>
        <tr class="column-header-row">
          <th class="col-header">
            <div class="group-header__title-inner">
              <span class="material-symbols-outlined table-header-icon">
                {{additDataSource.data.length ? 'expand_circle_up' : 'expand_circle_down'}}
              </span>
              {{getFeeGroupingDisplayName('additional', 'Additional Fees')}}
            </div>
          </th>
          <th class="col-header col-header--right col-header--current">Amount</th>
          <th class="col-header col-header--right col-header--proposed">Proposed Amount</th>
          <th class="col-header col-header--right col-header--savings">Savings</th>
        </tr>
      </thead>
      <tbody>
        @for (additFee of additDataSource.data; track additFee) {
        <tr class="data-row">
          <td class="cell">{{additFee.label}}</td>
          <td class="cell cell--right">{{additFee.amount | currency}}</td>
          <td class="cell cell--right">{{additFee.proposedAmount | currency}}</td>
          <td class="cell cell--right">{{getFeeSavings(additFee) | currency}}</td>
        </tr>
        }
      </tbody>
      <tfoot>
        <tr class="footer-row">
          <td class="cell cell--bold">Total</td>
          <td class="cell cell--right cell--bold">{{costComparison.comparisonFeeGroupings.additional.totalAmount |
            currency}}</td>
          <td class="cell cell--right cell--bold">{{costComparison.comparisonFeeGroupings.additional.proposedTotalAmount
            | currency}}</td>
          <td class="cell cell--right cell--bold">
            {{getFeeGroupingSavings(costComparison.comparisonFeeGroupings.additional) | currency}}</td>
        </tr>
      </tfoot>
    </table>
  </div>

  <!-- ASSESSMENT FEES TABLE -->
  <div class="fee-table">
    <table class="fees-table additional-fees-table full-width" (click)="toggleAssessmentTable()">
      <colgroup>
        <col style="width: 30%">
        <col style="width: 25%">
        <col style="width: 25%">
        <col style="width: 20%">
      </colgroup>
      <thead>
        <tr class="column-header-row">
          <th class="col-header">
            <div class="group-header__title-inner">
              <span class="material-symbols-outlined table-header-icon">
                {{assessDataSource.data.length ? 'expand_circle_up' : 'expand_circle_down'}}
              </span>
              {{getFeeGroupingDisplayName('assessment', 'Assessment Fees')}}
            </div>
          </th>
          <th class="col-header col-header--right col-header--current">Amount</th>
          <th class="col-header col-header--right col-header--proposed">Proposed Amount</th>
          <th class="col-header col-header--right col-header--savings">Savings</th>
        </tr>
      </thead>
      <tbody>
        @for (assessFee of assessDataSource.data; track assessFee) {
        <tr class="data-row">
          <td class="cell">{{assessFee.label}}</td>
          <td class="cell cell--right">{{assessFee.amount | currency}}</td>
          <td class="cell cell--right">{{assessFee.proposedAmount | currency}}</td>
          <td class="cell cell--right">{{getFeeSavings(assessFee) | currency}}</td>
        </tr>
        }
      </tbody>
      <tfoot>
        <tr class="footer-row">
          <td class="cell cell--bold">Total</td>
          <td class="cell cell--right cell--bold">{{costComparison.comparisonFeeGroupings.assessment.totalAmount |
            currency}}</td>
          <td class="cell cell--right cell--bold">{{costComparison.comparisonFeeGroupings.assessment.proposedTotalAmount
            | currency}}</td>
          <td class="cell cell--right cell--bold">
            {{getFeeGroupingSavings(costComparison.comparisonFeeGroupings.assessment) | currency}}</td>
        </tr>
      </tfoot>
    </table>
  </div>

  <!-- NON-NEGOTIABLE FEES TABLE -->
  <div class="fee-table">
    <table class="fees-table additional-fees-table full-width" (click)="toggleNonNegotiableTable()">
      <colgroup>
        <col style="width: 30%">
        <col style="width: 25%">
        <col style="width: 25%">
        <col style="width: 20%">
      </colgroup>
      <thead>
        <tr class="column-header-row">
          <th class="col-header">
            <div class="group-header__title-inner">
              <span class="material-symbols-outlined table-header-icon">
                {{nonNegotDataSource.data.length ? 'expand_circle_up' : 'expand_circle_down'}}
              </span>
              {{getFeeGroupingDisplayName('nonNegotiable', 'Non-Negotiable Fees')}}
            </div>
          </th>
          <th class="col-header col-header--right col-header--current">Amount</th>
          <th class="col-header col-header--right col-header--proposed">Proposed Amount</th>
          <th class="col-header col-header--right col-header--savings">Savings</th>
        </tr>
      </thead>
      <tbody>
        @for (nnFee of nonNegotDataSource.data; track nnFee) {
        <tr class="data-row">
          <td class="cell">
            {{nnFee.label}}
            @if (nnFee.isFlagged) {
            <i class="fas fa-comment-dollar mat-text-accent" [matTooltip]="flagText"></i>
            }
          </td>
          <td class="cell cell--right">{{nnFee.amount | currency}}</td>
          <td class="cell cell--right">{{nnFee.proposedAmount | currency}}</td>
          <td class="cell cell--right">{{getFeeSavings(nnFee) | currency}}</td>
        </tr>
        }
      </tbody>
      <tfoot>
        <tr class="footer-row">
          <td class="cell cell--bold">Total</td>
          <td class="cell cell--right cell--bold">{{costComparison.comparisonFeeGroupings.nonNegotiable.totalAmount |
            currency}}</td>
          <td class="cell cell--right cell--bold">
            {{costComparison.comparisonFeeGroupings.nonNegotiable.proposedTotalAmount | currency}}</td>
          <td class="cell cell--right cell--bold">
            {{getFeeGroupingSavings(costComparison.comparisonFeeGroupings.nonNegotiable) | currency}}</td>
        </tr>
      </tfoot>
    </table>
  </div>

  <!-- INTERCHANGE FEES TABLE -->
  <div class="fee-table">
    <table class="fees-table additional-fees-table full-width" (click)="toggleInterchangeTable()">
      <colgroup>
        <col style="width: 30%">
        <col style="width: 25%">
        <col style="width: 25%">
        <col style="width: 20%">
      </colgroup>
      <thead>
        <tr class="column-header-row">
          <th class="col-header">
            <div class="group-header__title-inner">
              <span class="material-symbols-outlined table-header-icon">
                {{icDataSource.data.length ? 'expand_circle_up' : 'expand_circle_down'}}
              </span>
              {{getFeeGroupingDisplayName('interchange', 'Interchange Fees')}}
            </div>
          </th>
          <th class="col-header col-header--right col-header--current">Amount</th>
          <th class="col-header col-header--right col-header--proposed">Proposed Amount</th>
          <th class="col-header col-header--right col-header--savings">Savings</th>
        </tr>
      </thead>
      <tbody>
        @for (icFee of icDataSource.data; track icFee) {
        <tr class="data-row">
          <td class="cell">
            {{icFee.label}}
            @if (icFee.isFlagged) {
            <i class="fas fa-comment-dollar mat-text-accent" [matTooltip]="flagText"></i>
            }
          </td>
          <td class="cell cell--right">{{icFee.amount | currency}}</td>
          <td class="cell cell--right">{{icFee.proposedAmount | currency}}</td>
          <td class="cell cell--right">{{getFeeSavings(icFee) | currency}}</td>
        </tr>
        }
      </tbody>
      <tfoot>
        <tr class="footer-row">
          <td class="cell cell--bold">Total</td>
          <td class="cell cell--right cell--bold">{{costComparison.comparisonFeeGroupings.interchange.totalAmount |
            currency}}</td>
          <td class="cell cell--right cell--bold">
            {{costComparison.comparisonFeeGroupings.interchange.proposedTotalAmount | currency}}</td>
          <td class="cell cell--right cell--bold">
            {{getFeeGroupingSavings(costComparison.comparisonFeeGroupings.interchange) | currency}}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>